import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getRequiredUom, getSpeciesName } from "../../constants/Catch";
import Grid from "@mui/material/Grid";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import { useSelector } from "react-redux";

export default function SpeciesCode(props) {
  const species = useSelector((state) => state.validation.validations.species);
  const prefs = useSelector((state) => state.auth.vtr_preferences.species);
  const helpText = useSelector((state) => state.helpText.helpText || []);
  const [speciesFiltered, setSpecies] = useState([]);
  const [prefsFiltered, setPrefs] = useState([]);
  const [selectedValue, setValue] = useState({});

  useEffect(() => {
    if (species) {
      let tmpSpeciesCodes = [];
      let tmpSpeciesFiltered = species
        .map((item) => {
          // * Combining species names with synonymous
          let newObj = {
            SPPCODE: item.SPPCODE,
            SPPNAME: item.SPPSYN + ", " + item.SPPNAME,
            ITIS: item.ITIS,
          };
          if (item.hasOwnProperty("X_RPT_TYPE")) {
            newObj.X_RPT_TYPE = item.X_RPT_TYPE;
          }
          if (item.hasOwnProperty("REQUIRED_UOM")) {
            newObj.REQUIRED_UOM = item.REQUIRED_UOM;
          }
          if (item.hasOwnProperty("DISABLED")) {
            newObj.DISABLED = item.DISABLED;
          }
          return newObj;
        })
        .filter((item) => {
          // * Get a list of species codes to be excluded to filter the vtr prefs
          if (
            (item.hasOwnProperty("X_RPT_TYPE") &&
              item.X_RPT_TYPE.includes(props.reportType)) ||
            (item.hasOwnProperty("DISABLED") && item.DISABLED === true)
          ) {
            tmpSpeciesCodes.push(item.SPPCODE);
          }
          return (
            (item.hasOwnProperty("X_RPT_TYPE") &&
              !item.X_RPT_TYPE.includes(props.reportType)) ||
            !item.hasOwnProperty("X_RPT_TYPE")
          );
        });
      // * Setting the species filtered
      setSpecies(tmpSpeciesFiltered);
      // * Setting the selected value
      let currentSpecies = {
        SPPCODE: props.speciescode,
        SPPNAME: getSpeciesName(props.speciescode, tmpSpeciesFiltered),
      };
      let uomRequired = getRequiredUom(props.speciescode, tmpSpeciesFiltered);
      if (uomRequired) {
        currentSpecies.REQUIRED_UOM = uomRequired;
      }
      setValue(currentSpecies);

      // * User Species prefs section
      const prefList = prefs.filter((pref) => !tmpSpeciesCodes.includes(pref));
      let prefDetail = [];
      prefList.forEach((item) => {
        // * Combining species names with synonymous
        const speciesName = getSpeciesName(item, tmpSpeciesFiltered);
        if (speciesName !== "") {
          let newObj = {
            SPPCODE: item,
            SPPNAME: speciesName,
          };
          let prefRequiredUom = getRequiredUom(item, tmpSpeciesFiltered);
          if (prefRequiredUom) {
            newObj.REQUIRED_UOM = prefRequiredUom;
          }
          prefDetail.push(newObj);
        }
      });
      setPrefs(prefDetail);
    }
  }, [species, prefs, props.reportType, props.speciescode]);

  return (
    <Box mt={0} width="100%" align="center" key={"species_code_box"}>
      <h2 className="sectionTitle center">Species</h2>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        key={"species_code_grid"}
        direction="column"
      >
        <Grid item xs={12} md="auto" key={"species_code_grid_item"}>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            key={"species_code_grid_box"}
          >
            {prefsFiltered.map((species) => (
              <Box m={0.5} key={"species_code_box_" + species.SPPCODE}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="form-input"
                  data-new-value={species}
                  data-field={"species"}
                  size="large"
                  onClick={(e) => props.changeHandler(e, species)}
                  id={species.SPPCODE}
                  key={species.SPPCODE}
                >
                  {species.SPPCODE}
                </Button>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item key={"species_code_grid_auto"}>
          <Autocomplete
            id="species_auto_complete"
            key={"species_code_auto"}
            options={speciesFiltered || []}
            getOptionLabel={(option) => option.SPPCODE + " " + option.SPPNAME}
            style={{ maxWidth: 350, minWidth: 300 }}
            onChange={props.changeHandler}
            value={selectedValue}
            isOptionEqualToValue={(option) =>
              option.SPPCODE + " " + option.SPPNAME
            }
            getOptionDisabled={(option) => option.DISABLED === true}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Species"
                variant="standard"
                helperText="Species Name or Code"
              />
            )}
          />
          <HelpText helpText={getHelpText(helpText, "species_code")} />
        </Grid>
      </Grid>
    </Box>
  );
}
